import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
// import { getToken } from 'shared/local-storage'
import RouterUrlHelper from '../../routes/RouterUrlHelper';
import { ITgUser } from '../../types';

const useAuthProtection = (params?: { authRedirect: string }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [tgUser, setTgUser] = useState<ITgUser | null>(null);
  const history = useHistory();
  useEffect(() => {
    const token = window.localStorage.getItem('tgUser');

    if (!token) {
      history.push(RouterUrlHelper.urlMap.login.path);
      return;
    }

    // if (!params || !params.authRedirect) {
    //   history.push(RouterUrlHelper.urlMap.accounts.path);
    //   return;
    // }

    if (params && params.authRedirect) {
      history.push(params.authRedirect);
      return;
    }

    setTgUser(JSON.parse(token));
    setIsLoading(false);
  }, [history]);

  return {
    isLoading,
    tgUser,
  };
};

export default useAuthProtection;
